module.exports = __webpack_public_path__ + "static/media/VisionImage.3c02a889.jpg";